<template>
  <v-container fluid class="pa-2">
    <v-layout row justify-center>
      <v-flex xs12 sm10 md8 lg6>
        <v-card flat class="elevation-2">
          <v-card-title class="justify-center pb-0 pt-3">
            <div class="text-xs-center">
              <v-avatar size="56" color="primary darken-2" class="mb-2">
                <v-icon dark size="28">store</v-icon>
              </v-avatar>
              <h1 class="title font-weight-bold primary--text text--darken-2">
                Become a Vendor
              </h1>
              <p class="caption grey--text mt-1">Join our marketplace community</p>
            </div>
          </v-card-title>

          <v-card-text class="px-3 pb-4">

            <!-- Loading -->
            <div v-if="loading" class="text-xs-center py-4">
              <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
            </div>

            <!-- Error -->
            <div v-else-if="error" class="text-xs-center py-4">
              <v-icon color="error" size="40">error</v-icon>
              <p class="mt-2 caption">{{ error }}</p>
              <v-btn small color="primary" @click="loadStatus">Retry</v-btn>
            </div>

            <!-- Approved Seller -->
            <div v-else-if="isSeller" class="text-xs-center py-3">
              <v-alert type="success" :value="true">
                <div class="font-weight-bold">You are an approved vendor!</div>
                <div class="caption mt-1">Your shop is live and ready</div>
              </v-alert>
              <v-btn color="primary darken-2" dark round small :to="dashboardLink" class="mt-3">
                <v-icon left small>dashboard</v-icon>
                Go to Dashboard
              </v-btn>
            </div>

            <!-- Pending -->
            <div v-else-if="hasApplication && application.status === 'PENDING'" class="text-xs-center py-4">
              <v-progress-circular indeterminate color="warning" size="50" class="mb-2"></v-progress-circular>
              <h2 class="subheading warning--text font-weight-bold">Under Review</h2>
              <p class="caption grey--text mt-1">
                Submitted on {{ formatDate(application.created_at) }}<br>
                We will notify you once approved
              </p>
              <v-chip small color="warning" text-color="white">Pending</v-chip>
            </div>

            <!-- Rejected or New Application -->
            <div v-else class="py-2">

              <v-alert v-if="hasApplication && application.status === 'REJECTED'"
                type="error" :value="true" class="mb-4">
                <div class="font-weight-bold">Application Rejected</div>
                <div v-if="application.rejection_reason" class="caption mt-1">
                  Reason: {{ application.rejection_reason }}
                </div>
              </v-alert>

              <div class="text-xs-center mb-4">
                <v-icon size="36" color="primary">edit_document</v-icon>
                <h2 class="body-2 font-weight-bold primary--text mt-2">
                  {{ hasApplication ? 'Resubmit Your Application' : 'Start Your Application' }}
                </h2>
              </div>

              <v-text-field
                v-model="form.business_name"
                label="Business Name *"
                prepend-icon="store"
                required
                box
                dense
              ></v-text-field>

              <div class="text-xs-right mt-3">
                <v-btn
                  :loading="submitting"
                  :disabled="!form.business_name.trim()"
                  color="primary darken-2"
                  dark round small
                  @click="submitForm"
                >
                  <v-icon left small>send</v-icon>
                  Submit Application
                </v-btn>
              </div>

            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SellerApplication',

  data() {
    return {
      loading: true,
      error: null,
      isSeller: false,
      application: null,
      submitting: false,
      dashboardLink: '/business-account/market_place/seller/dashboard',
      form: { business_name: '' }
    }
  },

  computed: {
    hasApplication() {
      return !!(this.application && this.application.id)
    }
  },

  mounted() {
    this.loadStatus()
  },

  methods: {
    async loadStatus() {
      this.loading = true
      this.error = null
      try {
        const res = await axios.get('/api/v1/market_place/seller/application/status/')
        this.isSeller    = res.data.is_seller === true
        this.application = res.data.application || null
      } catch {
        this.error = 'Unable to load status. Please try again.'
      } finally {
        this.loading = false
      }
    },

    async submitForm() {
      if (!this.form.business_name.trim()) return
      this.submitting = true
      try {
        const res = await axios.post('/api/v1/market_place/seller/apply/', {
          business_name: this.form.business_name.trim()
        })
        this.$store.commit('setSnackBarMessage', res.data.message || 'Application submitted!')
        this.$store.commit('setSnackBarColor', 'success')
        this.$store.commit('activateSnackBar', true)
        this.form.business_name = ''
        this.$router.push('/business-account/dashboard')
        await this.loadStatus()
      } catch (err) {
        const msg = err.response?.data?.error || 'Error submitting application'
        this.$store.commit('setSnackBarMessage', msg)
        this.$store.commit('setSnackBarColor', 'error')
        this.$store.commit('activateSnackBar', true)
      } finally {
        this.submitting = false
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return 'N/A'
      return new Date(dateStr).toLocaleDateString()
    }
  }
}
</script>